import React from "react";
import Flagship from "../../core/flagship";
import Filters from "../misc/Filters";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import {
  Table,
  Loader,
  Button,
  Label,
  Input,
  Icon,
  Menu,
  Modal,
  Header,
} from "semantic-ui-react";
import {
  throttle,
  renderFieldValue,
  empty,
  ucfirst,
} from "../../utils/helpers";
import Exporter from "../misc/Exporter";
import moment from "moment-business-days";

class Records extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.jumpToPage = this.jumpToPage.bind(this);
    this.filterStatus = this.filterStatus.bind(this);
    this.filterMarket = this.filterMarket.bind(this);
    this.filterSearch = this.filterSearch.bind(this);
    this.onFilterToggle = this.onFilterToggle.bind(this);
    this.selectAllFilters = this.selectAllFilters.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.search = this.search.bind(this);
    this.toggleFiltersVisibility = this.toggleFiltersVisibility.bind(this);
    this.toggleExportVisibility = this.toggleExportVisibility.bind(this);
    this.exportPage = this.exportPage.bind(this);
    this.exportData = this.exportData.bind(this);
    this.saveData = this.saveData.bind(this);
    this.timer = null;
    this.exportHeadings = {
      rfp: ["ID", "Name", "Client", "Market", "Due", "DBS", "Status"],
      io: ["ID", "Name", "RFP", "Market", "Submitted", "DBS", "Status"],
      client: ["Name", "Market", "Meeting", "AEs", "Status"],
    };
  }

  getInitialState() {
    let filterStatus = this.props.location.query.status;
    let filterMarket = this.props.location.query.market;
    let orderBy = this.props.location.query.orderby;

    let currentFilters = {};

    if (!empty(filterStatus) && filterStatus !== "any") {
      currentFilters.status = filterStatus;
    }

    if (!empty(filterMarket) && filterMarket !== "any") {
      currentFilters.market = filterMarket;
    }

    if (!empty(orderBy)) {
      currentFilters.orderby = orderBy;
    }

    return {
      currentFilters,
      currentPage: 1,
      records: [],
      totalCount: 0,
      totalPages: 1,
      loading: true,
      filtersVisible: false,
      exportVisible: false,
      expandedFilters: false,
      exporting: false,
      exportProgress: 0,
    };
  }

  componentWillMount() {
    // Call API
    this.getRecords();
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    document.title = "Flagship / " + this.props.route.niceName;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.route.type !== "client" && nextProps.userRole === "ae") {
      Flagship.redirect("/access-denied");
    }

    if (
      nextProps.route.type !== this.props.route.type ||
      nextProps.instance !== this.props.instance
    ) {
      document.title = "Flagship / " + nextProps.route.niceName;
      this.setState(this.getInitialState(), this.getRecords);
    }
  }

  getRecords() {
    let self = this;

    let data = Object.assign(
      {
        instance: this.props.instance,
      },
      this.state.currentFilters
    );

    Flagship.get(
      "list/" + this.props.route.type + "/" + this.state.currentPage,
      data,
      function (response) {
        if (response.data.success === true) {
          self.setState({
            records: response.data.results,
            totalCount: response.data.totalCount,
            totalPages: Math.ceil(response.data.totalCount / 15),
            loading: false,
          });
        } else {
          Flagship.error("Error getting records from Flagship API server.");
        }
      },
      function (err) {
        Flagship.error(
          "Error getting records from Flagship API server: " + err
        );
      }
    );
  }

  clearFilters(parameter = false) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (parameter) {
      // Only clear one filter group
      delete newFilters[parameter];
    } else {
      newFilters = [];
    }

    this.setState(
      {
        currentFilters: newFilters,
        exportStart: null,
        exportEnd: null,
      },
      this.getRecords
    );
  }

  selectAllInGroup(key, possibleFilters) {
    let newFilters = [];

    if (Array.isArray(possibleFilters[key])) {
      possibleFilters[key].map((item) => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    } else {
      Object.keys(possibleFilters[key]).map((item) => {
        if (typeof newFilters[key] !== "undefined") {
          newFilters[key].push(item);
        } else {
          newFilters[key] = [item];
        }
      });
    }
    return newFilters;
  }

  selectAllFilters(parameter = false, possibleFilters) {
    let newFilters = Object.assign({}, this.state.currentFilters);
    let self = this;

    if (parameter) {
      newFilters = Object.assign(
        newFilters,
        this.selectAllInGroup(parameter, possibleFilters)
      );
    } else {
      Object.keys(possibleFilters).map((key) => {
        newFilters = Object.assign(
          newFilters,
          self.selectAllInGroup(key, possibleFilters)
        );
      });
    }

    this.setState(
      {
        currentFilters: newFilters,
      },
      this.getRecords
    );
  }

  onFilterToggle(filterName, filterKey) {
    let newFilters = Object.assign({}, this.state.currentFilters);

    if (typeof newFilters[filterName] !== "undefined") {
      const index = newFilters[filterName].indexOf(filterKey);
      if (index >= 0) {
        newFilters[filterName].splice(index, 1);
      } else {
        newFilters[filterName].push(filterKey);
      }
    } else {
      newFilters[filterName] = [filterKey];
    }
    this.setState(
      {
        currentFilters: newFilters,
      },
      this.getRecords
    );
  }

  prevPage() {
    this.setState(
      {
        currentFilters: [],
        currentPage:
          this.state.currentPage > 1
            ? this.state.currentPage - 1
            : this.state.currentPage,
      },
      this.getRecords
    );
  }

  nextPage() {
    this.setState(
      {
        currentFilters: [],
        currentPage:
          this.state.currentPage < this.state.totalPages
            ? this.state.currentPage + 1
            : this.state.currentPage,
      },
      this.getRecords
    );
  }

  jumpToPage(page) {
    this.setState(
      {
        currentPage: page,
        loading: true,
      },
      this.getRecords
    );
  }

  addFilter(filter, value, currentFilters) {
    if (typeof currentFilters[filter] !== "undefined") {
      currentFilters[filter].push(value);
    } else {
      currentFilters[filter] = [value];
    }
    return currentFilters;
  }

  filterStatus(e, { value }) {
    let currentFilters = Object.assign({}, this.state.currentFilters);

    if (value === "any") {
      delete currentFilters["status"];
    } else {
      currentFilters = this.addFilter("status", value, currentFilters);
    }

    this.setState({ currentFilters: currentFilters }, this.getRecords);
  }

  filterMarket(e, { value }) {
    let currentFilters = Object.assign({}, this.state.currentFilters);

    if (value === "any") {
      delete currentFilters["market"];
    } else {
      currentFilters = this.addFilter("market", value, currentFilters);
    }

    this.setState({ currentFilters: currentFilters }, this.getRecords);
  }

  filterSearch(value) {
    let currentFilters = Object.assign({}, this.state.currentFilters);

    if (value === "") {
      delete currentFilters["search"];
    } else {
      currentFilters["search"] = value;
    }

    this.setState({ currentFilters: currentFilters }, this.getRecords);
  }

  search(e) {
    e.persist();
    let filterSearch = this.filterSearch;
    this.timer = throttle(
      function () {
        filterSearch(e.target.value);
      },
      500,
      this.timer
    );
  }

  toggleFiltersVisibility() {
    this.setState({
      filtersVisible: !this.state.filtersVisible,
    });
  }

  toggleExportVisibility() {
    this.setState({
      exportVisible: !this.state.exportVisible,
    });
  }

  saveData() {
    let filename =
      "Records_" +
      ucfirst(this.props.route.type) +
      "_" +
      moment().format("MM-DD-YYYY") +
      ".csv";

    const processRow = function (row) {
      let finalVal = "";
      for (let j = 0; j < row.length; j++) {
        let innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        let result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        finalVal += result;
      }
      return finalVal + "\n";
    };

    let csvFile = "";

    csvFile += processRow(this.exportHeadings[this.props.route.type]);

    for (let i = 0; i < this.state.exportData.length; i++) {
      csvFile += processRow(this.state.exportData[i]);
    }

    let blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  clean(results) {
    // Clean up results
    let data = [];
    let recordType = this.props.route.type;
    let recordTypeConfig = Flagship.config.records[recordType];

    results.map((item) => {
      if (recordType !== "client") {
        data.push([
          "#" + item.record_key,
          item.record_name,
          recordType === "io"
            ? item.extra1.hasOwnProperty("name")
              ? item.extra1.name +
                (item.extra1.hasOwnProperty("key")
                  ? " (#" + item.extra1.key + ")"
                  : "")
              : "-"
            : item.extra1.hasOwnProperty("name")
            ? item.extra1.name
            : "-",
          item.market,
          item.extra3 === "" || item.extra3 === null || item.extra3 < 9999
            ? "-None-"
            : moment.unix(item.extra3).format("MM/DD/YYYY"),
          item.extra2 === "" || item.extra2 === null
            ? "-None-"
            : typeof item.extra2 === "number"
            ? item.first_name + " " + item.last_name
            : item.extra2,
          recordTypeConfig.statuses.hasOwnProperty(item.record_status)
            ? recordTypeConfig.statuses[item.record_status].label
            : "Unknown",
        ]);
      } else {
        data.push([
          item.record_name,
          item.market,
          item.extra3 === "" || item.extra3 === null || item.extra3 < 9999
            ? "-None-"
            : moment.unix(item.extra3).format("MM/DD/YYYY"),
          item.extra2 === "" || item.extra2 === null
            ? "-None-"
            : typeof item.extra2 === "number"
            ? item.first_name + " " + item.last_name
            : item.extra2.join(),
          recordTypeConfig.statuses.hasOwnProperty(item.record_status)
            ? recordTypeConfig.statuses[item.record_status].label
            : "Unknown",
        ]);
      }
    });
    return data;
  }

  exportPage(page) {
    let self = this;

    let data = Object.assign(
      {
        instance: this.props.instance,
        pageSize: 250,
      },
      this.state.currentFilters
    );

    Flagship.get(
      "list/" + this.props.route.type + "/" + page,
      data,
      function (response) {
        if (response.data.success === true) {
          let totalPages = Math.ceil(response.data.totalCount / 250);

          let cleanData = self.clean(response.data.results);
          let newExportData = [...self.state.exportData, ...cleanData];
          self.setState(
            {
              exportData: newExportData,
              exportProgress: page / totalPages,
            },
            () => {
              if (page < totalPages) {
                self.exportPage(page + 1);
              } else {
                self.setState(
                  {
                    exportProgress: 100,
                    exporting: false,
                  },
                  self.saveData
                );
              }
            }
          );
        } else {
          Flagship.error("Error exporting records from Flagship API server.");
        }
      },
      function (err) {
        Flagship.error(
          "Error exporting records from Flagship API server: " + err
        );
      }
    );
  }

  exportData() {
    let self = this;
    this.setState(
      {
        exporting: true,
        exportProgress: 0,
        exportData: [],
      },
      () => {
        self.exportPage(1);
      }
    );
  }

  render() {
    let recordType = this.props.route.type;
    let recordTypeConfig = Flagship.config.records[recordType];
    let self = this;

    let possibleFilters = {
      status: recordTypeConfig.statuses,
      market: Flagship.config.markets,
    };

    if (recordType === "rfp" && this.props.userRole === "ae") {
      return <div className="white-text">Access to RFPs is denied.</div>;
    }

    const displayBody = () => {
      if (this.state.loading) {
        return (
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="6">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else if (!this.state.records.length) {
        return (
          <Table.Body>
            <Table.Row className="no-results">
              <Table.Cell colSpan="6">
                <Icon name="thumbs down" size="huge" />
                <h3>Nothing Found.</h3>
                <p>
                  Flagship did not find any records that match the criteria
                  you've selected.
                </p>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        );
      } else {
        return (
          <Table.Body>
            {typeof this.state.records === "object" &&
            this.state.records !== null
              ? this.state.records.map(function (row, i) {
                  if (row.record_type === recordType) {
                    return (
                      <Table.Row key={i}>
                        <Table.Cell key="name">
                          <Link
                            to={"/" + recordType + "/view/" + row.record_key}
                          >
                            {row.record_name}
                          </Link>
                        </Table.Cell>
                        <Table.Cell key="market">
                          <Link
                            to={"/" + recordType + "/view/" + row.record_key}
                          >
                            <Label horizontal>{row.market}</Label>
                          </Link>
                        </Table.Cell>
                        <Table.Cell key="extra1">
                          {row.extra1.key === "00000000" ? (
                            <Link
                              to={"/" + recordType + "/view/" + row.record_key}
                            >
                              Advisr
                            </Link>
                          ) : (
                            <div>
                              {!empty(row.extra1) ? (
                                empty(row.extra1.link) ||
                                typeof row.extra1.link === "function" ? (
                                  <Link
                                    to={
                                      "/" +
                                      recordType +
                                      "/view/" +
                                      row.record_key
                                    }
                                  >
                                    {renderFieldValue(
                                      row.extra1,
                                      recordTypeConfig.extra1.validation
                                    )}
                                  </Link>
                                ) : (
                                  <div className="records-table-link">
                                    {renderFieldValue(
                                      row.extra1,
                                      recordTypeConfig.extra1.validation
                                    )}
                                  </div>
                                )
                              ) : null}
                            </div>
                          )}
                        </Table.Cell>
                        {self.props.instance !== "SHIFT" ||
                        self.props.route.type !== "client" ? (
                          <Table.Cell key="extra2">
                            <Link
                              to={"/" + recordType + "/view/" + row.record_key}
                            >
                              {renderFieldValue(
                                row.extra2,
                                recordTypeConfig.extra2.validation
                              )}
                            </Link>
                          </Table.Cell>
                        ) : null}
                        <Table.Cell key="extra3">
                          <Link
                            to={"/" + recordType + "/view/" + row.record_key}
                          >
                            {renderFieldValue(
                              row.extra3,
                              recordTypeConfig.extra3.validation
                            )}
                          </Link>
                        </Table.Cell>
                        <Table.Cell key="status">
                          <Link
                            to={"/" + recordType + "/view/" + row.record_key}
                          >
                            <Label
                              horizontal
                              color={
                                recordTypeConfig.statuses[row.record_status]
                                  .color
                              }
                            >
                              {
                                recordTypeConfig.statuses[row.record_status]
                                  .label
                              }
                            </Label>
                          </Link>
                        </Table.Cell>
                      </Table.Row>
                    );
                  } else {
                    return null;
                  }
                })
              : null}
          </Table.Body>
        );
      }
    };

    let currentFilters = this.state.currentFilters;
    let search = this.search;

    const hasActiveFilters = () => {
      if (Object.keys(currentFilters).length <= 1) {
        return false;
      }
      let returnVal = false;
      Object.keys(currentFilters).map(function (filter) {
        if (filter !== "instance" && currentFilters[filter].length > 0) {
          returnVal = true;
        }
      });
      return returnVal;
    };

    let viewTitle = <h1 className="view-title">{this.props.route.niceName}</h1>;

    return (
      <div className="fade-in">
        <div id="view-header-section">
          {viewTitle}
          {this.props.accessLevel === 2 &&
          ((this.props.userRole !== "ae" && this.props.route.type !== "rfp") ||
            this.props.userMarket === "Chicago" ||
            this.props.instance === "SHIFT") ? (
            <Button
              as={Link}
              to={"/" + recordType + "/create"}
              className="view-create-new"
            >
              <Icon name="plus" />
              Create New
            </Button>
          ) : null}
          <div className="view-filters">
            {this.state.filtersVisible === true || hasActiveFilters() ? (
              <Button
                onClick={this.toggleFiltersVisibility}
                color="pink"
                className="filter-data filtering-active"
              >
                <Icon name="filter" />
                Filtering Data
              </Button>
            ) : (
              <Button
                onClick={this.toggleFiltersVisibility}
                className="filter-data"
              >
                <Icon name="filter" />
                Filter Data...
              </Button>
            )}

            {this.props.userRole === "admin" ? (
              <Button
                onClick={this.toggleExportVisibility}
                className="export-data"
              >
                <Icon name="download" />
                Export Data...
              </Button>
            ) : null}

            {this.props.route.type === "rfp" ? (
              <Button as={Link} to="/line-items" className="view-switch">
                <Icon name="eye" />
                By Line Item...
              </Button>
            ) : null}

            {this.props.route.type === "io" ? (
              <Button as={Link} to="/io-products" className="view-switch">
                <Icon name="eye" />
                By Product...
              </Button>
            ) : null}
          </div>

          <div className="view-search">
            <Input
              placeholder={"Search " + this.props.route.niceName + "..."}
              onKeyUp={search}
            />
          </div>
        </div>

        {this.state.filtersVisible ? (
          <Modal open={true} closeIcon onClose={this.toggleFiltersVisibility}>
            <Filters
              active={currentFilters}
              possible={possibleFilters}
              parameters={{ status: "Status", market: "Market" }}
              matches={this.state.totalCount}
              onToggle={this.onFilterToggle}
              onSelectNone={this.clearFilters}
              onSelectAll={(parameter) =>
                this.selectAllFilters(parameter, possibleFilters)
              }
            />
          </Modal>
        ) : null}

        {this.state.exportVisible ? (
          <Modal open={true} closeIcon onClose={this.toggleExportVisibility}>
            <Exporter
              mainHeading="Export Data"
              onSelectNone={this.clearFilters}
              doExport={this.exportData}
            />
            <Filters
              active={currentFilters}
              possible={possibleFilters}
              parameters={{ status: "Status", market: "Market" }}
              matches={this.state.totalCount}
              onToggle={this.onFilterToggle}
              onSelectNone={this.clearFilters}
              onSelectAll={(parameter) =>
                this.selectAllFilters(parameter, possibleFilters)
              }
            />
          </Modal>
        ) : null}

        {this.state.exporting ? (
          <Modal open={true}>
            <Header>Exporting...</Header>
            <div className="export-progress">
              <div
                className="export-progress-inner"
                style={{ width: this.state.exportProgress * 100 + "%" }}
              >
                <span>{Math.round(this.state.exportProgress * 100)}%</span>
              </div>
            </div>
          </Modal>
        ) : null}

        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Market</Table.HeaderCell>
              <Table.HeaderCell>
                {recordTypeConfig.extra1.label}
              </Table.HeaderCell>
              {this.props.instance !== "SHIFT" ||
              this.props.route.type !== "client" ? (
                <Table.HeaderCell>
                  {recordTypeConfig.extra2.label}
                </Table.HeaderCell>
              ) : null}
              <Table.HeaderCell>
                {recordTypeConfig.extra3.label}
              </Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {displayBody()}
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6" className="view-pagination">
                <Menu pagination>
                  {this.state.currentPage > 1 ? (
                    <Menu.Item icon onClick={this.prevPage}>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron left" />
                    </Menu.Item>
                  )}

                  {this.state.currentPage > 3 ? (
                    <Menu.Item name="1" onClick={() => this.jumpToPage(1)} />
                  ) : null}

                  {this.state.currentPage > 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage > 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage > 1 ? (
                    <Menu.Item
                      name={String(this.state.currentPage - 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage - 1)
                      }
                    />
                  ) : null}

                  <Menu.Item
                    name={String(this.state.currentPage)}
                    active={true}
                    onClick={() => this.jumpToPage(this.state.currentPage)}
                  />

                  {this.state.currentPage < this.state.totalPages - 1 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 1)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 1)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 2 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 2)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 2)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 2 &&
                  this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 3)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 3)
                      }
                    />
                  ) : null}

                  {this.state.currentPage <= 1 &&
                  this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item
                      name={String(this.state.currentPage + 4)}
                      onClick={() =>
                        this.jumpToPage(this.state.currentPage + 4)
                      }
                    />
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 4 ? (
                    <Menu.Item disabled>...</Menu.Item>
                  ) : null}

                  {this.state.currentPage < this.state.totalPages - 3 ? (
                    <Menu.Item
                      name={String(this.state.totalPages)}
                      onClick={() => this.jumpToPage(this.state.totalPages)}
                    />
                  ) : null}

                  {this.state.currentPage !== this.state.totalPages ? (
                    <Menu.Item icon onClick={this.nextPage}>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  ) : (
                    <Menu.Item icon disabled>
                      <Icon name="chevron right" />
                    </Menu.Item>
                  )}
                </Menu>
                <div className="total-records">
                  Found {this.state.totalCount}
                  {empty(this.state.currentFilters)
                    ? " total " + this.props.route.niceName + "."
                    : " " +
                      this.props.route.niceName +
                      " matching your search criteria."}
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

Records.propTypes = {
  actions: PropTypes.object,
  token: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    userRole: state.main.userRole,
    accessLevel: state.main.accessLevel,
    instance: state.main.instance,
    userMarket: state.main.userMarket,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Records);



// WEBPACK FOOTER //
// ./src/components/views/Records.js